import { render, staticRenderFns } from "./contract-detail.vue?vue&type=template&id=533b2e61&scoped=true"
import script from "./contract-detail.vue?vue&type=script&lang=js"
export * from "./contract-detail.vue?vue&type=script&lang=js"
import style0 from "./contract-detail.vue?vue&type=style&index=0&id=533b2e61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b2e61",
  null
  
)

export default component.exports